import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationModule } from '../../i18n/translation-module';
import { OnResizeDirective } from './on-resize.directive';
import { ObserversModule } from '@angular/cdk/observers';

@Component({
  selector: 'crm-collapsible-section',
  template: `
    <div class="collapsible-content">
      <div
        #collapsibleContentContainer
        crmOnResize
        (resizeDetected)="checkForOverflow()"
        (cdkObserveContent)="checkForOverflow()"
        [style.max-height.px]="collapsed() ? maxHeightPx : undefined"
        [ngClass]="{
          'collapsed-content-container': collapsed(),
          'collapsed-content-container-border': collapsed() && showBorderWhenCollapsed,
        }"
      >
        <ng-content></ng-content>
      </div>
      <div
        *ngIf="collapsible() && collapsed()"
        class="collapsed-content-overlay"
        [style.max-height.px]="maxHeightPx"
      ></div>
    </div>
    <p
      *ngIf="collapsible()"
      class="toggle-collapsed-button"
      [ngClass]="{
        'toggle-collapsed-button-view-less-state': !collapsed(),
      }"
      (click)="toggleCollapsed()"
    >
      {{ (collapsed() ? 'COLLAPSIBLE_SECTION.VIEW_MORE' : 'COLLAPSIBLE_SECTION.VIEW_LESS') | translate }}
    </p>
  `,
  styleUrls: ['./collapsible-section.component.scss'],
  imports: [CommonModule, TranslateModule, TranslationModule, ObserversModule, OnResizeDirective],
})
export class CollapsibleSectionComponent {
  @ViewChild('collapsibleContentContainer') collapsibleContentContainer!: ElementRef;

  @Input() maxHeightPx = 300;
  @Input() showBorderWhenCollapsed = false;

  // collapsed must be set initially for overflow to be detected otherwise the max-height won't be set
  collapsed = signal<boolean>(true);
  collapsible = signal<boolean>(false);

  toggleCollapsed() {
    this.collapsed.update((value) => !value);
  }

  checkForOverflow() {
    // collapsible if
    // - scrollable content is higher than the visible content
    // - content is larger than the maximum height
    const element = this.collapsibleContentContainer.nativeElement;
    const isOverflow = element.scrollHeight > element.offsetHeight || element.offsetHeight > this.maxHeightPx;
    this.collapsible.set(isOverflow);
  }
}
